import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import connect from 'dojo/_base/connect';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import on from 'dojo/on';
import Moveable from 'dojo/dnd/Moveable';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from 'moreCore/UI/GenericDialog/GenericDialog';
import OccurrenceFilters from './OccurrenceFilters';
import OccurrenceList from './OccurrenceList';
import OccurrenceFormDialog from 'WidgetCollection/Occurrence/OccurrenceFormDialog/OccurrenceFormDialog';
import OccurrenceOfflineManager from './OccurrenceOfflineManager';
import template from './OccurrenceHome.html?raw';
export default declare("WidgetCollection.JDM.Occurrence.OccurrenceHome", [_WidgetBaseSP], {
        templateString: template,

        occurrenceDialog: null,
        //occurrenceList: null, // ist schon im Template
        _submitInProgess: false,
        employee: null,
        _selectedFiltermode: "",//"MyOccurrences",
        _occurrenceFiltersInitialized: false,
        genericDialog: null,

        online: true,
        _offlineManager: null,

        _sessionEstablished: function () {
            this._getCurrentEmployee();
        },

        _onOfflineOnlineChanged: function () {
            domClass.remove(this.connectionStatus, "w3-text-green w3-text-red w3-pale-red");
            domAttr.set(this.connectionStatusLabel, "innerHTML", "");

            var mainContent = document.getElementById("mainContent");
            

            if (navigator.onLine == true) {
                this.online = true;
                domClass.remove(mainContent, "offline");
                domClass.add(this.connectionStatus, "w3-text-green mds-bg-gray");
                domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Online"]);

            } else {
                this.online = false;
                domClass.add(mainContent, "offline");
                domClass.add(this.connectionStatus, "w3-text-red w3-pale-red");
                domAttr.set(this.connectionStatusLabel, "innerHTML", this.translations["General_Offline"]);
            }
        },

        _onOfflineManagerMessage: function (bError, message) {
            domClass.remove(this.offlineManagerMessage, "w3-text-red");

            if (bError) {
                domClass.add(this.offlineManagerMessage, "w3-text-red");
            }

            if (message == null || typeof (message) == "undefined") {
                if (bError == true) {
                    message = "error";
                } else {
                    message = "";
                }
            }
            
            domAttr.set(this.offlineManagerMessage, "innerHTML", message);

        },

        _onClick_OfflineManager: function (evt) {
            this.showOfflineManager();
        },

        showOfflineManager: function (bShow) {
            var dialog = new GenericDialog();

            dialog.hideSubtitleNode();
            domStyle.set(dialog.textNode, "height", "unset");

            dialog.set("header", this.translations["OccurrenceOfflineManager_Title"]);

            dialog.addNodeToContent(this._offlineManager.domNode);
            dialog.set("callback", lang.hitch(this, "showOfflineManagerCallback"));
            dialog.set("ok", false);
            dialog.set("close", true);
            //dialog.set("cancel", true);

            dialog.show();
        },

        showOfflineManagerCallback: function (result) {
            domConstruct.place(this._offlineManager.domNode, this.OfflineManagerContainerHidden);
        },

        startup: function () {

            this.inherited(arguments);

            if (this._offlineManager == null) {
                this._offlineManager = new OccurrenceOfflineManager();
                this._offlineManager.startup();
                this._onOfflineOnlineChanged();
            }

            var title = this.translations["OccurrenceHome__MainTitle"];
            if (title == "" || title == null || typeof (title) == "undefined") {
                title = "ekus Meldewesen";
            }
            document.title = title;
            document.occurrenceHome = this;

            this.occurrenceFilters.occurrenceList = this.occurrenceList;
            this.occurrenceList.homePanel = this;
            this.occurrenceList.startup();

            //console.log("window.lastLoginResponse", window.lastLoginResponse);

            //setTimeout(this._getCurrentEmployee(), 500); // kleine Racecondition...
            //this._getCurrentEmployee();  

            this.checkSiteAction();
        },

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);

            
        },

        checkSiteAction: function () {
            
            var paramNames = this.getUrlParameterNames();

            if (paramNames != false) {
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var value = this.getUrlParameterValue(param);

                    if (value != false) {
                        switch (param.toUpperCase()) {
                            case "VIEW":
                                // Kommentar auch gewünscht?
                                var commentId = this.getUrlParameterValue("qa");

                                if (commentId != false) {
                                    this.showOccurrenceDialog(value, null, commentId);
                                } else {
                                    this.showOccurrenceDialog(value, null); // Schreibschutz wird 
                                }

                                return; // RAUS
                                break;

                            case "CREATE":

                                var dlg = this.showOccurrenceDialog();
                                dlg.occurrenceForm.inputOccurrenceType.selectedValue = value;
                                return;
                                break;

                            case "RATE":
                                this.startRating(entityId);
                                return;
                                break;

                            default:
                                //alert(this.translations["OccurrenceHome__ErrorDialog_InvalidURLParams"]);
                                break;

                        }
                    } else {
                        this.removeUrlParameter(param);
                    }
                }
            }
        },

        _getCurrentEmployee: function () {
            this.StandbyStart();
            var url = window.appRoot + "Occurrence/GetCurrentEmployeeJSON";

            this.RequestManager.post(
                url,
                {
                },
                lang.hitch(this, "_onGetCurrentEmployeeResponse"),
                lang.hitch(this, function (error) {
                    console.error("current employee fehler", error.Message);
                }),
                false // sync
            );
        },

        _onGetCurrentEmployeeResponse: function (response) {
            this.StandbyStop();
            this.employee = response;
            var bIsEditor = false;

            console.log("occurrenceHome currentEmployee", this.employee);

            if (this.occurrenceDialog != null) { 
                this.occurrenceDialog.set("Employee", this.employee);
            }

            if (this.employee != null) {
                this.inputLocation._loadListValues(this.employee.ref_last_location, true); // suppress change!
                domClass.remove(this.locationContainer, "w3-hide");
            } 

            if (this.employee.Classname != "Employee") {
                //domClass.add(this.btnNewOccurrence, "w3-hide");
            } else {
                //domClass.remove(this.btnNewOccurrence, "w3-hide");
            }

            domClass.remove(this.btnNewOccurrence, "w3-hide");

            this.occurrenceFilters.pushStep("employeeLocation");

            // prüfen ob der employee zu einer Bearbeiter-Gruppe gehört
            for (var i = 0; i < this.employee.groupList.length; i++) {
                var group = this.employee.groupList[i];

                if (group.is_occurrence_group == true) {
                    //this.filterContainer.set("employee", this.employee);
                    this.set("FilterMode", "Editor");
                    domClass.remove(this.occurrenceFilters.domNode, "w3-hide");
                    domClass.remove(this.btnFilterEditor, "w3-hide");
                    domClass.remove(this.btnFilterMyOccurrences, "w3-hide");
                    this.occurrenceList._isEditor = true;
                    bIsEditor = true;

                    //domClass.remove(this.opt_complete_by_asc, "w3-hide");
                    //domClass.remove(this.opt_complete_by_desc, "w3-hide");

                    //// ein Bearbeiter darf seine Emails einschränken
                    //domClass.remove(this.containerLimitMailsToLocation, "w3-hide");

                    //// Einschränkugn der Emails einblenden
                    //domClass.remove(this.containerLimitMailsToLocation, "w3-disabled");
                    //if (this.employee.is_limit_mailnotifications_to_last_location === true) {
                    //    domAttr.set(this.inputLimitMailsToLocation, "checked", "checked");
                    //}

                    break;
                }
            }

            if (bIsEditor != true) {
                this.set("FilterMode", "MyOccurrences");
            }

            
            //this.filterContainer.startup();
        },

        startRating: function (entityId) {
            if (typeof (entityId) == "undefined") {
                return;
            }
            this.StandbyStart();
            var url = window.appRoot + "Occurrence/LoadOccurrenceJSON";

            this.RequestManager.post(
                url,
                {
                    occurrenceID: entityId
                },
                lang.hitch(this.occurrenceList, "ratingDialog", null),
                lang.hitch(this, "_onLoadOccurrenceError"),
                false // sync
            );
        },

        _onLoadOccurrenceError: function (error) {
            this.StandbyStop();
            var message = this.translations["OccurrenceHome__ErrorDialog_HeaderOccurrenceLoad"];
            this.showMessage(message, error.message);
            //alert(error.message);
        },

        showRatingDialog: function (entity) {
            this.StandbyStop();
            var dlg = new RatingDialog();
            dlg.set("entity", entity, "evaluation_occurrence", "note_evaluation");
            dlg.set("callback", lang.hitch(this, "ratingDialogCallback"));

            dlg.startup();
        },

        ratingDialogCallback: function () {
            this.removeUrlParameter("rate");
        },

        _setFilterModeAttr: function (value) {
            console.debug("set filtermode", value);
            if (this._selectedFiltermode != value) {
                this._selectedFiltermode = value;

                var selectedClasses = "accentcolor mds-hover-bright";
                var deselectedClasses = "mds-bg-gray mds-hover-dark";

                domClass.remove(this.btnFilterEditor, selectedClasses);
                domClass.remove(this.btnFilterEditor, deselectedClasses);
                domClass.remove(this.btnFilterMyOccurrences, deselectedClasses);
                domClass.remove(this.btnFilterMyOccurrences, selectedClasses);

                domAttr.set(this.occurrenceList.loadMessage, "innerHTML", "warte auf Filteroptionen...");
                
                this.occurrenceList._alternativeLoading = lang.hitch(this.occurrenceFilters, "applyFilters");
                domClass.remove(this.occurrenceFilters.domNode, "w3-hide");
                
                if (this._selectedFiltermode == "Editor") {
                    this.occurrenceFilters.set("Filtermode", "OccurrenceEdit");

                    domClass.add(this.btnFilterEditor, selectedClasses);
                    domClass.add(this.btnFilterMyOccurrences, deselectedClasses);

                    domClass.remove(this.opt_complete_by_asc, "w3-hide");
                    domClass.remove(this.opt_complete_by_desc, "w3-hide");

                } else {
                    this.occurrenceFilters.set("Filtermode", "default");

                    domClass.add(this.btnFilterEditor, deselectedClasses);
                    domClass.add(this.btnFilterMyOccurrences, selectedClasses);

                    domClass.add(this.opt_complete_by_asc, "w3-hide");
                    domClass.add(this.opt_complete_by_desc, "w3-hide");
                }  

                if (this._occurrenceFiltersInitialized != true) {
                    this.occurrenceFilters.startup(this.employee);
                    this._occurrenceFiltersInitialized = true;
                } else {
                    //this.occurrenceFilters.applyFilters();
                }
                
                //this.occurrenceList.loadOccurrences();
                
            }
        },

        _onChangeLocation: function (value) {
            //console.log("Location geändert", value);
            var additionalFct = lang.hitch(this, "_onSetLocation");

            this._saveUserSettings(additionalFct);
        },

        _onChangeLimitMailsToLocation: function () {
            this._saveUserSettings();
        },

        _saveUserSettings: function (callback) {
            this.StandbyStart(this.locationContainer);

            var jsonData = { location: this.inputLocation.get("value"), isLimitMailsToLocation: this.inputLimitMailsToLocation.checked == true };

            var url = window.appRoot + "Occurrence/SaveUserSettings";

            this.RequestManager.post(
                url,
                {
                    jsonData: JSON.stringify(jsonData)
                },
                lang.hitch(this, "_onSaveUserSettingsResponse", callback),
                lang.hitch(this, "_onSaveUserSettingsError"),
                false // sync
            );
        },

        _onSaveUserSettingsResponse: function (callback, response ) {
            this.StandbyStop();

            if (typeof (callback) == "function") {
                callback();
            }

        },

        _onSetLocation: function () {
            
            //if (this.occurrenceFilters.inputLimitToLocation.checked == true) {
            //    this.occurrenceFilters.pushStep("employeeLocation"); // mitteilen dass der Step fertig ist
            //}
            //this._showLocationMessage("Erfolgreich!", "fa-check w3-text-green", 1500);

            if (this.employee != null) { // falls gerade der Editor-Filtertab angezeigt wird: Location umschalten auf "null"
                this.occurrenceFilters._lastRequestParameters = null;
                this.employee.ref_last_location = this.inputLocation.get("value");
                this.occurrenceFilters.set("employee", this.employee);
                
                //if (this.occurrenceFilters.inputLimitToLocation.checked == true) {
                //    this.occurrenceFilters._reloadBuildingList(null);
                //}
            }
            
        },

        _onSaveUserSettingsError: function (error) {
            //this._showLocationMessage(error.Message, "fa-times w3-text-red", 30000);
            this.occurrenceFilters.StandbyStop();
            alert(error.Message);
            this.StandbyStop();
        },

        _showLocationMessage: function (message, iconClass, durationMS) {
            this._hideLocationMessage();
            //console.log("location message", typeof (durationMS), durationMS);
            if (typeof (durationMS) != "number") {
                durationMS = 1500;
            }
            domAttr.set(this.locationMessageContent, "innerHTML", message);
            domClass.remove(this.locationMessageIcon);
            domClass.add(this.locationMessageIcon, "fa " + iconClass);
            domClass.remove(this.locationMessageContainer, "w3-hide");
            domStyle.set(this.locationMessageContainer, "opacity", 1);

            setTimeout(lang.hitch(this, "_hideLocationMessage"), durationMS);
        },

        _hideLocationMessage: function () {
            domStyle.set(this.locationMessageContainer, "opacity", 0);

            setTimeout(lang.hitch(this, function() {
                domClass.add(this.locationMessageContainer, "w3-hide");
            }), 3000);
            
        },

        _onClick_Btn_FilterEditor: function (evt) {
            this.set("FilterMode", "Editor");
        },

        _onClick_Btn_FilterMyOccurrences: function (evt) {
            this.set("FilterMode", "MyOccurrences");
        },

        _onClick_NewOccurrence: function (evt) {
            if (this.employee == null) {
                return;
            }

            //if (this.employee.Classname != "Employee") {
            //    return;
            //}
            this.showOccurrenceDialog();
        },

        showOccurrenceDialog: function (occurrenceGUID, bReadOnly, commentId) {

            if (true) {//(this.occurrenceDialog == null) {
                var occurrenceDialog = new OccurrenceFormDialog();
                this.occurrenceDialog = occurrenceDialog;

                occurrenceDialog.employee = this.employee;
                on(occurrenceDialog, "EntitySaved", lang.hitch(this, "_onEntitySaved", occurrenceDialog));
                on(occurrenceDialog, "OccurrenceFormClosed", lang.hitch(this, "_onOccurrenceFormClosed", occurrenceDialog));
                

                domConstruct.place(occurrenceDialog.domNode, this.modalDlg);

                occurrenceDialog.startup(occurrenceGUID, bReadOnly, commentId);
            }

            return occurrenceDialog;
        },


        _onEntitySaved: function (occurrenceDialog) {
            
            var bIsNew = occurrenceDialog.occurrenceID == null;

            // total schiach: wenn der Dialog eine neue MEldung ist die an einer Hauptmeldung hängt, dann Abbruch
            if (occurrenceDialog.occurrenceForm.mainOccurrence.ID != null && bIsNew == true) {
                return;
            }

            this._onClick_Reload();
        },

        _onChangeSorting: function (evt) {
            console.log("sorting changed", this.inputSorting.value);

            if (this.occurrenceFilters != null) {
                this.occurrenceFilters.set("Sorting", this.inputSorting.value);
                return;
            }
        },

        _onChangeSearch: function (evt) {
            console.log("search changed", this.inputSearch.value);

            if (this.occurrenceFilters != null) {
                this.occurrenceFilters.set("searchKey", this.inputSearch.value);
                return;
            }
        },

        _onClick_Reload: function () {
            if (this._alternativeLoading != null) {
                this._alternativeLoading();
                return;
            }
            this.occurrenceFilters._lastRequestParameters = null;
            this.occurrenceList.loadOccurrences(0);
            
        },

        _onOccurrenceFormClosed: function () {

            if (this.removeUrlParameter("view") != false) {
            }

            if (this.removeUrlParameter("create") != false) {
            }

            if (this.removeUrlParameter("qa") != false) {
            }

            //this.siteActionReset();
        },


        showMessage: function (header, message, subtitle, callback) {
            var dialog = new GenericDialog();

            if (typeof (subtitle) == "string") {
                dialog.set("subtitle", subtitle);
            } else {
                dialog.hideSubtitleNode();
            }

            this.genericDialog = dialog;
            domStyle.set(dialog.textNode, "height", "unset");

            dialog.set("header", header);
            dialog.set("content", message);
            dialog.set("callback", lang.hitch(this, "showMessageCallback", callback));

            dialog.set("ok", true);
            //dialog.set("cancel", true);

            dialog.show();
        },

        showMessageCallback: function (callback) {
            if (typeof (callback) == "function") {
                callback();
            }

            this.genericDialog = null;
        },

        _setupSubscriptions: function () {
            this.inherited(arguments);

            this._subscriptions.push(connect.subscribe("/Session/CheckForExistingSession", lang.hitch(this, "_sessionEstablished")));
            this._subscriptions.push(connect.subscribe("/OfflineManager/OfflineStateChange", lang.hitch(this, "_onOfflineOnlineChanged")));
            this._subscriptions.push(connect.subscribe("/OfflineManager/Message", lang.hitch(this, "_onOfflineManagerMessage")));
            
        }
    });
